import { BasePaginateResultSchema } from '@/api/common.ts'
import dayjs from 'dayjs'
import { z } from 'zod'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

// Enum for machine status
export const MachineStatus = {
  IDLE: 0,
  OUT_OF_SERVICE: 1,
  RUNNING: 2,
}

// Define the enum values as union of string literals
export const MachineTrackingModelSchema = z
  .object({
    id: z.number().optional(),
    machineId: z.number(),
    workOrderScheduleId: z.number().nullable(),
    startTime: z
      .string()
      .nullable()
      .transform((val) =>
        val ? dayjs(val, 'YYYY-MM-DDTHH:mm:ss').tz('utc', true).toDate() : null
      ),
    estimatedCompletionTime: z
      .string()
      .nullable()
      .transform((val) =>
        val ? dayjs(val, 'YYYY-MM-DDTHH:mm:ss').tz('utc', true).toDate() : null
      ),
    status: z.number().default(MachineStatus.IDLE),
    lotNo: z.string().nullable(),
    itemId: z.number().nullable(),
    outOfServiceReason: z.string().nullable(),
    notes: z.string().nullable(),
  })
  .transform((data) => {
    return {
      ...data,
      statusLabel: getStatusLabel(data.status),
      statusColor: getStatusColor(data.status),
    }
  })

export type MachineTrackingModel = z.infer<typeof MachineTrackingModelSchema>

export const MachineTrackingResultSchema = z
  .object({
    data: z.array(MachineTrackingModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type MachineTrackingResult = z.infer<typeof MachineTrackingResultSchema>

function getStatusLabel(status: number) {
  switch (status) {
    case MachineStatus.IDLE:
      return 'ว่าง'
    case MachineStatus.RUNNING:
      return 'กำลังทำงาน'
    case MachineStatus.OUT_OF_SERVICE:
      return 'ไม่พร้อมใช้งาน'
    default:
      return ''
  }
}

function getStatusColor(status: number) {
  switch (status) {
    case MachineStatus.IDLE:
      return 'yellow'
    case MachineStatus.RUNNING:
      return 'green'
    case MachineStatus.OUT_OF_SERVICE:
      return 'pink'
    default:
      return ''
  }
}
